import React from 'react';
import { Container, LineIcon, Title, ButtonGroup, OpenLineLink, InstallLineLink } from './LineOpenPrompt.styled';

export interface LineOpenPromptProps {
  liffUrl: string;
  lineInstallUrl: string;
}

export const LineOpenPrompt: React.FC<LineOpenPromptProps> = ({ liffUrl, lineInstallUrl }) => {
  return (
    <Container>
      <LineIcon>
        <img src="/images/line-brand-icon.png" alt="LINE" width="80" height="80" />
      </LineIcon>
      <Title>{'LINEアプリを開いて\n続行してください。'}</Title>
      <ButtonGroup>
        <OpenLineLink href={liffUrl}>LINEアプリを開く</OpenLineLink>
        <InstallLineLink href={lineInstallUrl} target="_blank" rel="noopener noreferrer">
          LINEアプリをダウンロード
        </InstallLineLink>
      </ButtonGroup>
    </Container>
  );
};

export default LineOpenPrompt;
